import { styled } from "goober";
import type { ReactNode } from "react";
import { Icon, type IconName } from "../Icon";
import { Text } from "../Text";
import { DefaultIcon, HoverIcon, ToggleIconContainer } from "../ToggleIcon";
import { WavyLine } from "../WavyLine";
import { ChatDisclosure } from "./ChatDisclosure";

const ToolsContainer = styled("div")`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

export function ToolGroup({
  text,
  icon,
  pending = false,
  disabled = false,
  expanded,
  onToggle,
  children,
  keepMounted = false,
}: {
  text: string;
  icon: IconName;
  pending?: boolean;
  disabled?: boolean;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  keepMounted?: boolean;
}) {
  return (
    <ChatDisclosure
      header={
        <>
          {pending ? (
            <WavyLine size={12} color="var(--text-secondary)" opacity={1} />
          ) : (
            <ToggleIconContainer aria-hidden>
              <DefaultIcon>
                <Icon name={icon} size={12} color="var(--text-secondary)" />
              </DefaultIcon>
              <HoverIcon>
                <Icon
                  name={expanded ? "minus" : "plus"}
                  size={12}
                  color="var(--text-secondary)"
                />
              </HoverIcon>
            </ToggleIconContainer>
          )}
          <Text variant="text-small" color="var(--text-secondary)">
            {text}
          </Text>
        </>
      }
      disabled={disabled}
      expanded={expanded}
      onToggle={onToggle}
      content="plain"
      keepMounted={keepMounted}
    >
      <ToolsContainer>{children}</ToolsContainer>
    </ChatDisclosure>
  );
}
